export default __webpack_public_path__ + "static/media/questionFasting.4adebf47.svg";